import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import _ from 'lodash';

import MomentPropTypes from "../../../helpers/MomentPropTypes";
import t from '../../../lib/I18n';
import trainTime from '../../../lib/TrainTime';
import TrackingActions from "../../../actions/TrackingActions";

// cannot be a functional component as a ref is used (https://reactjs.org/docs/refs-and-the-dom.html#refs-and-functional-components)

export default class TodayTomorrowControls extends React.PureComponent {
    static propTypes = {
        startDate: MomentPropTypes.isMoment,
        disabled: PropTypes.bool,
        onChange: PropTypes.func,
        srOnly: PropTypes.string,
        autoFocusedElt: PropTypes.func
    };

    static defaultProps = {
        startDate: trainTime(),
        disabled: false,
        onChange: _.noop,
        srOnly: '',
        autoFocusedElt: _.noop
    };

    render () {
        const { disabled, onChange, startDate, srOnly, autoFocusedElt } = this.props;

        const controlClass = classnames('btn-link like-link');

        const changeHandler = (date, type) => () => {
            TrackingActions.widgetSearchClick({ name: type });
            if (startDate && !disabled) {
                onChange(date.set({
                    hour: startDate.hour(),
                    minute: startDate.minute()
                }));
            }
        };

        return (
            <div className="calendar-dropdown__controls clearfix">
                <button className={ controlClass + " pull-left" }
                    disabled={ disabled }
                    onClick={ changeHandler(trainTime().clone(), 'today') }
                    ref={ autoFocusedElt }>
                    { srOnly &&
                        <span className="sr-only">{ srOnly }</span> }
                    { t('booking.dates.todayAt') }
                </button>
                <button className={ controlClass + " pull-right" }
                    disabled={ disabled }
                    onClick={ changeHandler(trainTime().clone().add(1, 'day'), 'tomorrow') }>
                    { srOnly &&
                        <span className="sr-only">{ srOnly }</span> }
                    { t('booking.dates.tomorrowAt') }
                </button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/search/dates/TodayTomorrowControls.js